/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import axios from "axios";

export default function ContactUs() {
  const { t } = useTranslation();

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate required fields
    const { name, phone, email, subject } = formData;
    if (!name || !phone || !email || !subject) {
      Swal.fire({
        title: t("Error"),
        text: t("Please fill all required fields"),
        icon: "error",
        confirmButtonColor: "#E56820",
        customClass: {
          popup: "rounded-2xl shadow-2xl bg-white",
          title: "text-xl font-semibold text-[#E56820]",
          confirmButton:
            "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#c54e17] transition-all duration-200",
        },
      });
      setIsSubmitting(false);
      return;
    }

    // Confirmation dialog before submission
    const result = await Swal.fire({
      title: t("Confirm Submission"),
      text: t("Are you sure you want to send this message?"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#E56820",
      cancelButtonColor: "#ef4444",
      confirmButtonText: t("Yes, send it!"),
      cancelButtonText: t("Cancel"),
      customClass: {
        popup: "rounded-2xl shadow-2xl bg-white",
        title: "text-xl font-semibold text-[#E56820]",
        content: "text-gray-600",
        confirmButton:
          "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#c54e17] transition-all duration-200",
        cancelButton:
          "px-6 py-2 rounded-full bg-red-500 hover:bg-red-600 transition-all duration-200",
      },
    });

    if (result.isConfirmed) {
      try {
        await axios.post(
          "https://laravel-api.alburoujplast.com/api/contacts",
          formData
        );
        Swal.fire({
          title: t("Success"),
          text: t("Message sent successfully!"),
          icon: "success",
          confirmButtonColor: "#E56820",
          customClass: {
            popup: "rounded-2xl shadow-2xl bg-white",
            title: "text-xl font-semibold text-[#E56820]",
            content: "text-gray-600",
            confirmButton:
              "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#c54e17] transition-all duration-200",
          },
        });

        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          t("Failed to send message. Please try again.");
        Swal.fire({
          title: t("Error"),
          text: errorMessage,
          icon: "error",
          confirmButtonColor: "#E56820",
          customClass: {
            popup: "rounded-2xl shadow-2xl bg-white",
            title: "text-xl font-semibold text-[#E56820]",
            content: "text-gray-600",
            confirmButton:
              "px-6 py-2 rounded-full bg-[#E56820] hover:bg-[#c54e17] transition-all duration-200",
          },
        });
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="landingPages">
        <div className="container h-full flex items-center justify-between">
          <div className="w-100 w-[48%] flex flex-col">
            <div className="f-40 text-[50px] font-bold capitalize text-white">
              {t("Contact Us")}
            </div>
            <div className="font-bold text-[20px] text-white capitalize flex items-center gap-[7px]">
              <Link className="text-white" to={"/"}>
                {t("Home")}
              </Link>
              -
              <div className="text-white">{t("Contact Us")}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="f-col g-res-15 container flex flex-wrap justify-between">
          {/* PHONE CARD — جعل كل رقم رابط tel منفصل */}
          <div className="dir-ar w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center">
            <div className="bg-[#E56820] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
              <img
                src={require("../../assets/icons/phone-contact.svg").default}
                alt="phone"
              />
            </div>
            <div>
              <div className="text-[23px] font-bold capitalize text-[#E56820]">
                {t("phone")}
              </div>
              <a
                href="tel:+962770850085"
                className="font-bold [direction:ltr] block hover:underline"
                aria-label="+962 77 085 0085"
              >
                +962 77 085 0085
              </a>
              <a
                href="tel:+962777147639"
                className="font-bold [direction:ltr] block hover:underline"
                aria-label="+962 77 714 7639"
              >
                +962 77 714 7639
              </a>
            </div>
          </div>

          {/* EMAIL CARD — يفتح برنامج البريد */}
          <a
            href="mailto:info@alburoujplast.com"
            className="w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center"
            aria-label="Send email to info@alburoujplast.com"
          >
            <div className="bg-[#E56820] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
              <img
                src={require("../../assets/icons/email-contact.svg").default}
                alt="email"
              />
            </div>
            <div>
              <div className="text-[23px] font-bold capitalize text-[#E56820]">
                {t("email")}
              </div>
              <div className="font-bold">info@alburoujplast.com</div>
            </div>
          </a>

          {/* LOCATION CARD — يفتح الخرائط بتبويب جديد */}
          <a
            href="https://maps.app.goo.gl/NkMLBNcorRjeFphu8"
            target="_blank"
            rel="noopener noreferrer"
            className="w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center"
            aria-label="Open location in Google Maps"
          >
            <div className="bg-[#E56820] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
              <img
                src={require("../../assets/icons/location-contact.svg").default}
                alt="location"
              />
            </div>
            <div>
              <div className="text-[23px] font-bold capitalize text-[#E56820]">
                {t("location")}
              </div>
              <div className="font-bold">{t("Madaba - Jordan")}</div>
            </div>
          </a>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="f-col container flex justify-between gap-[20px]">
          <div className="w-100 w-[100%]">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col gap-[20px]">
                <div className="flex flex-col gap-[8px]">
                  <div className="f-col flex gap-[10px]">
                    <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                      <label className="font-bold text-[#E56820] capitalize">
                        {t("your name")}
                      </label>
                      <input
                        className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder={t("your name")}
                        required
                      />
                    </div>
                    <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                      <label className="font-bold text-[#E56820] capitalize">
                        {t("your phone")}
                      </label>
                      <input
                        className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder={t("your phone")}
                        required
                      />
                    </div>
                  </div>
                  <div className="f-col flex gap-[10px]">
                    <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                      <label className="font-bold text-[#E56820] capitalize">
                        {t("your email")}
                      </label>
                      <input
                        className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder={t("your email")}
                        required
                      />
                    </div>
                    <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                      <label className="font-bold text-[#E56820] capitalize">
                        {t("subject")}
                      </label>
                      <input
                        className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        placeholder={t("subject")}
                        required
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-[4px]">
                    <label className="font-bold text-[#E56820] capitalize">
                      {t("your message")}
                    </label>
                    <textarea
                      className="h-[250px] max-h-[300px] outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder={t("your message")}
                    />
                  </div>
                </div>
                <button
                  className="bg-[#e56820] text-white px-4 py-2 rounded-full font-bold text-[17px] capitalize disabled:opacity-50 disabled:cursor-not-allowed"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <span>
                    {isSubmitting ? t("Sending...") : t("send")}
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="relative py-[40px] flex flex-col gap-[10px]">
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3397.6857933802053!2d35.767154675615345!3d31.61506837417077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDM2JzU0LjMiTiAzNcKwNDYnMTEuMCJF!5e0!3m2!1sen!2sjo!4v1752489993264!5m2!1sen!2sjo"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            className="w-full"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* زر عرض الموقع يفتح بتبويب جديد */}
        <a
          href="https://maps.app.goo.gl/NkMLBNcorRjeFphu8"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#e56820] text-white px-[20px] py-2 rounded-full capitalize mx-auto"
        >
          <span>{t("View Location")}</span>
        </a>
      </section>
    </>
  );
}
